<ng-container *transloco="let t; read: 'findMyAgent.bedrooms'">
  <label class="text-heading-2 text-steel-100 mb-6 block" id="bedrooms-label">{{
    t('title', { propertyType: store.propertyTypeLabel$ | async | transloco | lowercase })
  }}</label>
  <rma-group-select class="flex flex-col space-y-4" [formControl]="control" aria-labelledby="bedrooms-label">
    @for (option of options; track option; let i = $index) {
      <rma-group-select-option #optionItem [option]="option" [optionTemplate]="optionTemplate" [tabindex]="i + 1">
        <ng-template #optionTemplate>
          <div
            class="bg-blue-10 hover:text-blue-10 active:text-blue-10 flex items-center justify-center p-4 font-bold text-blue-100 hover:bg-blue-50 focus:border focus:border-blue-100 active:bg-blue-100"
            [class.bg-blue-100]="optionItem.selected"
            [class.text-blue-10]="optionItem.selected"
            [attr.data-id]="'bedrooms-' + option.label">
            <span class="mr-1">{{ option.label }}</span>
            <span>{{ t('label', { count: option.value === 'one' ? 1 : 2 }) }} </span>
          </div>
        </ng-template>
      </rma-group-select-option>
    }
  </rma-group-select>
</ng-container>
